import Stack from '@zenbusiness/zui/Stack';
import PropTypes from 'prop-types';

import LinkedBankAccount from './LinkedBankAccount';

export default function LinkedBankAccountList({
  listLinkedBankAccount,
  usedAt = null,
  disable = false
}) {
  return (
    <Stack direction="column">
      {listLinkedBankAccount.map(
        (
          {
            id,
            bank,
            accountNumber,
            status,
            accountType,
            connectedType,
            name,
            fullAccountNumber,
            wire,
            isACHSupported,
            isWireSupported
          },
          idx
        ) => (
          <LinkedBankAccount
            accountNumber={accountNumber}
            accountType={accountType}
            bank={bank}
            connectedType={connectedType}
            disable={disable}
            fullAccountNumber={fullAccountNumber}
            id={id}
            isACHSupported={isACHSupported}
            isLatest={listLinkedBankAccount.length === idx + 1}
            isWireSupported={isWireSupported}
            key={id}
            name={name}
            status={status}
            usedAt={usedAt}
            wire={wire}
          />
        )
      )}
    </Stack>
  );
}
LinkedBankAccountList.propTypes = {
  listLinkedBankAccount: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      accountNumber: PropTypes.string.isRequired,
      status: PropTypes.string.isRequired,
      connectedType: PropTypes.string.isRequired,
      fullAccountNumber: PropTypes.string,
      wire: PropTypes.shape({
        address: PropTypes.shape({
          city: PropTypes.string,
          country: PropTypes.string,
          postalCode: PropTypes.string,
          state: PropTypes.string,
          street: PropTypes.string,
          street2: PropTypes.string
        }),
        routingNumber: PropTypes.string
      })
    })
  ).isRequired,
  disable: PropTypes.bool,
  usedAt: PropTypes.string
};
